import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TitleBar from "../../TitleBar";

// Internal Imports
import { FIELDS } from "../../../constants";

// Destructuring
const { FIELDS_VIEWS } = FIELDS;

class FieldsSidebar extends Component {
  state = {};

  render() {
    return (
      <div className="fields-settingssidebar col-md-2">
        <div className="fields-settingssidebar-title">
          <TitleBar
            iconName="cog"
            title="Form Fields"
            subTitle="This is the place to manage your fields."
          />
        </div>
        <ul className="fields-settingssidebar-list">
          {FIELDS_VIEWS.map(view => (
            <Link to={`${view.fullpath}`} key={view.name}>
              <li
                className={`fields-settingssidebar-item ${
                  this.props.match.url.includes(view.fullpath) ? "active" : ""
                }`}
                key={view.fullpath}
                data-test={`fields-settings-sidebar-view-${view.name}`}
                id={`fields-settings-sidebar-view-${view.name}`}>
                <span className="fields-settingssidebar-icon">
                  <FontAwesomeIcon icon={[view.faStyle, view.faIcon]} />
                </span>
                <span className="fields-settingssidebar-item-text">
                  {view.name}
                </span>
              </li>
            </Link>
          ))}
        </ul>
      </div>
    );
  }
}

export default FieldsSidebar;
